import React, { useState } from "react";
import { useParams, useLocation, Link, Navigate } from "react-router-dom";
import { getCityBySlug, CITIES } from "../data/cities";
import PageTopSlider from "../components/PageTopSlider";
import ContactForm from "../components/ContactForm";
import ReviewsSlider from "../components/ReviewsSlider";
import GalleryViewer from "../components/GalleryViewer";
import SEO from "../components/SEO";

export default function CityTrykprovning({ cityProp }) {
  const { citySlug } = useParams();
  const location = useLocation();

  const slugFromPath = location.pathname.replace(/^\/trykpro?evning-i-/, "");
  const city = cityProp || getCityBySlug(citySlug) || getCityBySlug(slugFromPath);

  const [openFaq, setOpenFaq] = useState(null);

  const faqList = [
    {
      q: "Hvad er en blowerdoor test?",
      a: "En blowerdoor test, også kaldet trykprøvning, er en metode til at måle, hvor tæt en bygning er. Ved hjælp af en speciel ventilator – en såkaldt blowerdoor – skabes et trykfald mellem bygningens indre og ydre. Det gør det muligt at registrere, hvor der slipper luft ud eller ind, og dermed identificere utætheder, som kan føre til energitab, træk og fugtproblemer.",
    },
    {
      q: "Hvad koster en blowerdoor test hos ET Danmark?",
      a: "Prisen for en blowerdoor test starter fra 3.300 kr. inkl. moms. Den endelige pris afhænger af bygningens størrelse og kompleksitet samt omfanget af den ønskede dokumentation. Testen udføres af certificerede teknikere med professionelt måleudstyr, og resultatet leveres som en rapport over bygningens lufttæthed.",
    },
    {
      q: "Hvordan foregår en trykprøvning?",
      a: "Bygningen klargøres efter den relevante prøvningsmetode. Herefter måles bygningens lufttæthed med BlowerDoor-udstyr ved kontrolleret over- og undertryk.",
    },
    {
      q: "Hvad viser resultatet af en blowerdoor test?",
      a: "Resultatet viser bygningens lufttæthed, typisk angivet som hvor meget luft, der siver ind eller ud pr. time ved et givent tryk. Et lavt tal betyder en tæt bygning med mindre varmetab og bedre energieffektivitet. Rapporten gør det muligt at lokalisere præcist, hvor der er behov for tætning eller forbedringer.",
    },
    {
      q: "Hvornår skal man lave en trykprøvning?",
      a: "En trykprøvning er særlig relevant ved nybyggeri, hvor man vil sikre, at bygningen lever op til energikravene i bygningsreglementet. Den kan også udføres i forbindelse med renovering eller energieftersyn af eksisterende bygninger for at finde utætheder, reducere energiforbruget og forbedre indeklimaet.",
    },
    {
      q: "Hvilke fordele er der ved trykprøvning af hus?",
      a: "Trykprøvning giver flere fordele: Lavere energiforbrug gennem tættere konstruktioner, bedre komfort uden træk og kolde zoner, sundere indeklima med reduceret risiko for fugt og skimmelsvamp samt øget ejendomsværdi, fordi dokumenteret energieffektivitet er attraktivt for købere.",
    },
    {
      q: "Hvem må udføre en blowerdoor test?",
      a: "Kun certificerede teknikere med professionelt måleudstyr bør udføre en blowerdoor test. Det kræver erfaring og præcision at opstille udstyret korrekt og tolke resultaterne, så de kan bruges som dokumentation over for myndigheder eller som grundlag for energiforbedringer.",
    },
    {
      q: "Hvor lang tid tager en trykprøvning?",
      a: "Varigheden afhænger af bygningens størrelse og kompleksitet. For et almindeligt enfamiliehus tager testen som regel få timer at udføre. Større bygninger eller ejendomme med mange rum kan tage længere tid, da forberedelse og målinger skal udføres mere detaljeret.",
    },
    {
      q: "Er trykprøvning et lovkrav ved nybyggeri?",
      a: "Ja. Ved nybyggeri stiller bygningsreglementet krav om, at bygningens lufttæthed skal dokumenteres. Trykprøvningen bruges som officiel dokumentation for, at energikravene er opfyldt. Den kan også være påkrævet i forbindelse med certificering eller aflevering af byggeriet.",
    },
    {
      q: "Hvad skal man forberede inden en trykprøvning?",
      a: "Inden testen bør alle døre og vinduer være monteret, og åbninger som aftræk og rørgennemføringer bør være færdiggjorte. Bygningen skal være ryddet, så teknikeren har fri adgang til relevante områder. Det er også vigtigt at følge eventuelle anvisninger fra den udførende konsulent for at sikre en præcis måling.",
    },
  ];

  if (!city) {
    return <Navigate to="/404" replace />;
  }

  const otherCities = CITIES.filter((c) => c.slug !== city.slug);

  return (
    <div className="bg-[#FAF9F6] text-stone-800">
      <SEO
        title={`Trykprøvning i ${city.name} | Kontakt os for en uforpligtende snak`}
        description={`Få trykprøvning i ${city.name} for at identificere og rette problemer relateret til bygningens tæthed. Opnå bedre energieffektivitet og komfort.`}
        canonical={`https://www.etdanmark.com/trykproevning-i-${city.slug}`}
        ogImage="https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07384_896fcb87.jpg"
        faqs={faqList}
      />
      {/* 1. TOP HERO */}
      <PageTopSlider
        title={`Trykprøvning i ${city.name}`}
        subtitle={`Få trykprøvning i ${city.name} for at identificere og rette problemer relateret til bygningens tæthed. Opnå bedre energieffektivitet og komfort.`}
        badge={`Certificeret BlowerDoor tekniker i ${city.name}`}
        priceBadge="Fra 3.300 kr. inkl. moms"
        breadcrumbs={[
          { label: "Forside", to: "/" },
          { label: "Trykprøvning", to: "/trykproevning" },
          { label: `Trykprøvning i ${city.name}` },
        ]}
        actions={
          <>
            <a
              href="tel:+4542499595"
              className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true"></i>
              <span>Ring: 42 49 95 95</span>
            </a>
            <Link
              to="/prisberegner"
              className="px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-white font-bold text-sm backdrop-blur-xs transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-calculator text-emerald-300 text-xs" aria-hidden="true"></i>
              <span>Beregn din pris</span>
            </Link>
          </>
        }
        image={{
          url: "https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07613.jpg",
          alt: `Trykprøvning og BlowerDoor i ${city.name}`,
        }}
      />

      {/* 2. INTRODUKTION & PRIS */}
      <section className="py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8 space-y-5">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-stone-900 tracking-tight">
                Trykprøvning og BlowerDoor i {city.name}
              </h2>
              <p className="text-stone-700 text-base leading-relaxed">
                Står du overfor en renovering eller nybyggeri og ønsker at sikre dig, at ejendommen er energieffektiv og fri for utætheder?
              </p>
              <p className="text-stone-700 text-base leading-relaxed">
                Trykprøvning er en essentiel service, der kan hjælpe dig med at identificere og rette problemer relateret til bygningens tæthed, hvilket sikrer bedre energieffektivitet og komfort i dit hjem, virksomhed eller institution.
              </p>
              <p className="text-stone-700 text-base leading-relaxed">
                Vi tilbyder trykprøvning i {city.name} og omegn, til en konkurrencedygtig pris. Ring i dag og få hjælp.
              </p>

              <div className="pt-2 flex flex-wrap gap-4 items-center">
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all inline-flex items-center gap-2"
                >
                  <span>Kontakt os</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
                <a
                  href="tel:+4542499595"
                  className="px-6 py-3 rounded-full bg-stone-100 hover:bg-stone-200 text-stone-800 font-bold text-sm transition-all inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-phone text-emerald-600 text-xs" aria-hidden="true"></i>
                  <span>Ring: 42 49 95 95</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="p-8 rounded-3xl bg-gradient-to-br from-emerald-900 to-emerald-950 text-white shadow-xl border border-emerald-800/40 text-center space-y-4">
                <div className="inline-block px-3 py-1 rounded-full bg-emerald-700/60 text-emerald-200 text-xs font-semibold uppercase tracking-wider">
                  Attraktiv pris
                </div>
                <div className="text-xs text-emerald-200 uppercase tracking-wider">
                  Vejledende pris
                </div>
                <div className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                  Fra 3.300 <span className="text-xl font-normal text-emerald-300">kr.</span>
                </div>
                <div className="text-xs text-emerald-200 font-medium">
                  inkl. moms & dokumenteret målerapport
                </div>
                <p className="text-xs text-emerald-300/90 pt-2 leading-relaxed border-t border-emerald-800/60">
                  Professionel måling af bygningens tæthed med kalibreret udstyr og hurtig udlevering af rapport til bygningsmyndigheder.
                </p>
                <Link
                  to="/prisberegner"
                  className="w-full mt-2 py-2.5 rounded-full bg-white hover:bg-stone-100 text-emerald-950 font-bold text-xs inline-flex items-center justify-center gap-2 transition-colors shadow-sm"
                >
                  <i className="fa-solid fa-calculator text-xs" aria-hidden="true"></i>
                  <span>Beregn samlet tilbud</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. HVAD ER TRYKPRØVNING & FORDELE */}
      <section className="py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-6 space-y-4">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
                Hvad er trykprøvning, også kendt som blowerdoor?
              </h2>
              <p className="text-stone-700 text-sm leading-relaxed">
                Trykprøvning er en metode til at måle, hvor tæt en bygning er. Ved at skabe et trykfald mellem bygningens indre og det ydre miljø, kan man opdage utætheder og andre fejl, der kan føre til energitab.
              </p>
              <p className="text-stone-700 text-sm leading-relaxed">
                Processen indebærer brug af avanceret udstyr som en blowerdoor, der opstiller en standardiseret luftstrøm for at presse luft ud eller ind i bygningen. Dette hjælper med at identificere, hvor luft lækker ud fra bygningen.
              </p>

              <div className="pt-4 space-y-4">
                <h3 className="text-xl font-bold text-stone-900">
                  Hvordan udføres trykprøvningen?
                </h3>
                <p className="text-stone-700 text-sm leading-relaxed">
                  Trykprøvning udføres typisk af certificerede teknikere, der anvender specialiseret udstyr til at måle lufttætheden. Processen omfatter følgende trin:
                </p>
                <div className="space-y-3 pt-1">
                  <div className="p-4 rounded-2xl bg-white border border-stone-200/80">
                    <p className="text-sm text-stone-700 leading-relaxed">
                      Bygningen klargøres efter den relevante prøvningsmetode. Herefter måles bygningens lufttæthed med BlowerDoor-udstyr ved kontrolleret over- og undertryk.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-6 space-y-6">
              <div className="p-8 rounded-3xl bg-white border border-stone-200/80 shadow-sm space-y-6">
                <h3 className="text-xl font-bold text-stone-900">
                  Fordele ved trykprøvning af hus og andet byggeri
                </h3>
                <p className="text-stone-600 text-sm">
                  Skal du have udført en grundig trykprøvning af huset i {city.name} kan du se frem til følgende fordele:
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="fa-solid fa-piggy-bank text-sm" aria-hidden="true"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-stone-900 text-sm">Energibesparelser</h4>
                      <p className="text-xs text-stone-600 mt-0.5">
                        Ved at identificere og forsegle utætheder, kan du reducere energiforbruget og dermed spare på dine energiregninger.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="fa-solid fa-wind text-sm" aria-hidden="true"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-stone-900 text-sm">Forbedret komfort</h4>
                      <p className="text-xs text-stone-600 mt-0.5">
                        Eliminer træk og kulde spots, der er resultatet af utætheder, hvilket skaber en mere behagelig bolig, eller arbejdsplads.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="fa-solid fa-shield-virus text-sm" aria-hidden="true"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-stone-900 text-sm">Sundere indeklima</h4>
                      <p className="text-xs text-stone-600 mt-0.5">
                        Reducerer risikoen for skimmelsvamp og fugt, ved at kontrollere luftstrømme ind og ud af byggeriet.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="fa-solid fa-house-chimney text-sm" aria-hidden="true"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-stone-900 text-sm">Øger værdien af dit hjem</h4>
                      <p className="text-xs text-stone-600 mt-0.5">
                        Et energieffektivt hjem med dokumenteret lavt energiforbrug, kan være mere attraktivt for købere, hvis du overvejer at sælge.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-3xl bg-emerald-950 text-white space-y-3">
                <h4 className="font-bold text-base">
                  Vælg den rette konsulent til at udføre blowerdoor i {city.name}
                </h4>
                <p className="text-xs text-emerald-200 leading-relaxed">
                  Når du vælger en konsulent til at udføre trykprøvning, er det vigtigt at vælge en med erfaring og de rette kvalifikationer.
                </p>
                <p className="text-xs text-emerald-200 leading-relaxed">
                  Hos ET Danmark ApS tilbyder vi professionel trykprøvning i {city.name} og omegn, med certificering i henhold til de nyeste standarder. Vi benytter kun det nyeste og mest præcise udstyr for at sikre, at du får de mest pålidelige resultater.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. TRYKPRØVNING I [BY] */}
      <section className="py-16 sm:py-20 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
                Trykprøvning i {city.name}
              </h2>
              <p className="text-stone-700 text-sm leading-relaxed">
                Har du brug for en professionel trykprøvning i {city.name}? Vi tilbyder trykprøvning af huse, virksomheder og institutioner i hele omegnen. Som certificerede energikonsulenter hjælper vi med at identificere utætheder i bygningens klimaskærm, så du får et klart overblik over, hvor der kan være varmetab eller behov for forbedringer.
              </p>
              <p className="text-stone-700 text-sm leading-relaxed">
                En trykprøvning er et effektivt værktøj til at dokumentere en bygnings lufttæthed og kan være relevant ved både nybyggeri, renovering og kvalitetssikring. Med en grundig gennemgang og professionelt måleudstyr sikrer vi en pålidelig test, der lever op til gældende krav. Uanset om du er privat boligejer, entreprenør eller virksomhed, står vi klar til at hjælpe med en effektiv og professionel trykprøvning i {city.name}.
              </p>

              <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-4">
                <h3 className="text-base font-bold text-stone-900">
                  Kontakt os for professionel rådgivning omkring trykprøvning/Blowerdoor i {city.name}
                </h3>
                <p className="text-xs text-stone-600 leading-relaxed">
                  Er du klar til at optimere dit hjem med professionel trykprøvning i {city.name}? Kontakt os i dag for at drøfte dine behov, og hvordan vi kan hjælpe dig med at opnå bedre energieffektivitet og komfort i dit hjem.
                </p>
                <div className="p-4 rounded-2xl bg-stone-50/90 border border-stone-200 text-xs text-stone-600 space-y-2 mt-4">
                  <div className="font-semibold text-stone-900">
                    Relaterede ydelser i {city.name}:
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <Link to={`/energimaerkning-i-${city.slug}`} className="text-emerald-700 hover:underline font-medium">
                      • Energimærkning i {city.name}
                    </Link>
                    <Link to={`/energikonsulent-i-${city.slug}`} className="text-emerald-700 hover:underline font-medium">
                      • Energikonsulent i {city.name}
                    </Link>
                    <Link to="/termografi" className="text-emerald-700 hover:underline font-medium">
                      • Termografisk undersøgelse
                    </Link>
                    <Link to="/energiramme" className="text-emerald-700 hover:underline font-medium">
                      • Energirammeberegninger
                    </Link>
                    {["aarhus", "horsens", "odense"].includes(city.slug) ? (
                      <Link to={`/fugtmaaling-i-${city.slug}`} className="text-emerald-700 hover:underline font-medium">
                        • Fugtmåling i {city.name}
                      </Link>
                    ) : (
                      <Link to="/fugtmaaling" className="text-emerald-700 hover:underline font-medium">
                        • Fugtmåling med Tramex
                      </Link>
                    )}
                    {["aarhus", "horsens", "vejle", "odense"].includes(city.slug) ? (
                      <Link to={`/lca-beregning-i-${city.slug}`} className="text-emerald-700 hover:underline font-medium">
                        • LCA-beregning i {city.name}
                      </Link>
                    ) : (
                      <Link to="/lca-beregning" className="text-emerald-700 hover:underline font-medium">
                        • LCA-beregning efter BR18
                      </Link>
                    )}
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 pt-1">
                  <a
                    href="tel:+4542499595"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs transition-colors"
                  >
                    <i className="fa-solid fa-phone text-xs" aria-hidden="true"></i>
                    <span>Ring: 42 49 95 95</span>
                  </a>
                  <a
                    href="mailto:info@etdanmark.com"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white hover:bg-stone-100 border border-stone-300 text-stone-800 font-bold text-xs transition-colors"
                  >
                    <i className="fa-solid fa-envelope text-emerald-600 text-xs" aria-hidden="true"></i>
                    <span>info@etdanmark.com</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-6">
              <div className="rounded-3xl overflow-hidden shadow-lg border border-stone-200">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07384_896fcb87.jpg"
                  alt={`Blowerdoor opstilling i ${city.name}`}
                  className="w-full h-80 object-cover object-center"
                />
              </div>

              <div className="p-6 rounded-3xl bg-stone-900 text-white space-y-3">
                <h3 className="font-bold text-base">Godkendt til nybyggeri</h3>
                <p className="text-xs text-stone-300 leading-relaxed">
                  Bygningsreglementet stiller krav om tæthedsdokumentation ved nybyg. Vi leverer den officielle rapport, som kommunen kræver for ibrugtagningstilladelse.
                </p>
                <div className="pt-2 border-t border-stone-800 flex items-center justify-between text-xs">
                  <span className="text-stone-400">Direkte kontakt:</span>
                  <a href="tel:+4542499595" className="text-emerald-400 font-bold hover:underline">
                    42 49 95 95
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. CMS GALLERI FOR TRYKPRØVNING */}
      <section className="py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <GalleryViewer
            gallerySlug="trykprovning"
            title={`Galleri: BlowerDoor trykprøvning i ${city.name} og omegn`}
            subtitle="Opstilling af ventilator, dørramme og måling på nybyg og renovering"
            maxImages={8}
          />
        </div>
      </section>

      {/* 6. FAQ OM TRYKPRØVNING */}
      <section className="py-16 sm:py-20 bg-white border-b border-stone-200/70">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Ofte stillede spørgsmål om blowerdoor test og trykprøvning
            </h2>
            <p className="text-stone-600 text-sm mt-2">
              Få svar på de mest almindelige spørgsmål om lufttæthedstest og måleprocessen
            </p>
          </div>

          <div className="space-y-3">
            {faqList.map((item, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div
                  key={idx}
                  className="rounded-2xl border border-stone-200 bg-stone-50/60 overflow-hidden transition-all"
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? null : idx)}
                    className="w-full text-left p-5 font-bold text-stone-900 flex items-center justify-between gap-4 hover:bg-stone-100/70 transition-colors"
                  >
                    <span className="text-sm sm:text-base">{item.q}</span>
                    <i
                      className={`fa-solid fa-chevron-down text-xs text-stone-500 transition-transform ${
                        isOpen ? "rotate-180 text-emerald-600" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-xs sm:text-sm text-stone-600 leading-relaxed border-t border-stone-200/50 pt-3">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 7. ANDRE BYER FOR TRYKPRØVNING */}
      <section className="py-12 bg-stone-100 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="text-lg font-bold text-stone-900 mb-2">
            Trykprøvning i andre byer i Jylland og Fyn:
          </h3>
          <p className="text-xs text-stone-600 mb-6">
            Klik på en by for at se information om trykprøvning og BlowerDoor i dit lokalområde
          </p>
          <div className="flex flex-wrap justify-center gap-2 max-w-4xl mx-auto">
            {otherCities.map((c) => (
              <Link
                key={c.slug}
                to={`/trykproevning-i-${c.slug}`}
                className="px-3.5 py-1.5 rounded-xl bg-white border border-stone-300/80 text-xs font-semibold text-stone-700 hover:bg-emerald-50 hover:border-emerald-500 hover:text-emerald-800 transition-all shadow-2xs"
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 8. REVIEWS */}
      <ReviewsSlider />

      {/* 9. KONTAKTFORMULAR */}
      <section className="py-16 sm:py-20 bg-stone-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Bestil trykprøvning i {city.name}
            </h2>
            <p className="text-sm text-stone-600 mt-2 max-w-lg mx-auto">
              Send en uforpligtende forespørgsel, og få hurtigt svar på dato og pris.
            </p>
          </div>

          <div className="bg-white p-6 sm:p-10 rounded-3xl border border-stone-200 shadow-sm">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}
